import React, { useState, useEffect } from "react";
import InfoTextAdv from "./InfoTextAdv";
import StatusTags from "../Tags/StatusTags";
import Button from "../Buttons/Button";
import AdvSeparator from "../Common/AdvSeparator";
import FormFieldSet from "../FormFields/FormFieldSet";
import { dateFormator, keyToTitle } from "../../utils";
import { formatWords2 } from "../../utils/stringUtils";
import { updateCompanystatusApi, updateEmailstatusApi } from "../../redux/slices/leads/leadsApi";
import { useSelector } from "react-redux";
import { showToast } from "../Toast/Toast";
import { convertFromUTC } from "../../utils/dateUtils";
import { jobStatuses } from "../../assets/data/enumData";
import SmartTooltip from "./SmartTooltip";

const AccountCard = ({
  data,
  statusOnChange,
  onLocationChange,
  currentCompany,
  handleAddNewLoc,
  lockInPeriodTime,
  raSetting,
  setCurrentCompany,
  isBdm = false,
  searchType = "company",
  searchValue
}) => {
  const [editStatus, setEditStatus] = useState(false);
  const [status, setStatus] = useState("");
  const { user } = useSelector((state) => state.auth);
  const role = user?.data?.role;
  // const canEditStatus = role?.type !== 2 || user?.data?.level === 5;
  const canEditStatus = isBdm || role?.type !== 2 || user?.data?.level === 5;
  // visible to everyone except RA users whose level ≠ 5
  // pick default location from data if available
  const defaultLocation =
    data?.location ||
    data?.companyLocation || // in case parent passes this key
    "";

  const [location, setLocation] = useState(defaultLocation);
  const prospectUiid =
  searchType === "Email" && searchValue
    ? currentCompany?.jobIds
        ?.flatMap(job => job.prospectIds)
        // ?.find(p => p.email?.email?.toLowerCase() === searchValue?.toLowerCase()) 
        ?.find(p => p.email?.email?.toLowerCase() === (typeof searchValue === "string"
          ? searchValue.toLowerCase()
          : searchValue?.email?.toLowerCase()
        )) 
        ?.uiid
    : null;

  const EMAIL_STATUS_MAP = {
    1: "Not Verified",
    2: "Verified",
    3: "Invalid",
  };

  const INPERSON_STATUS_MAP = {
    1: "Active",
    2: "Positive",
    3: "DNC",
  };
  const accountApprovalMap = {
    1: "Pending",
    2: "Approved",
    3: "Rejected",
  };

  const getProspectStatus = (prospect) => {
      return INPERSON_STATUS_MAP[prospect?.inpersonResponseStatus] || "Unknown";
  };

  // sync when data changes
  useEffect(() => {
    if (defaultLocation) {
      setLocation(defaultLocation);
    }
  }, [defaultLocation]);

  const { accountName, accountStatus, ...dataOther } = data;
  const prospect =
    searchType === "Email" && prospectUiid
      ? currentCompany?.jobIds
        ?.flatMap(job => job.prospectIds)
        ?.find(p => p.uiid === prospectUiid)
      : null;
  const displayedStatus = searchType === "Email"
    ? getProspectStatus(prospect)
    : accountStatus;

  const handleChangeStatus = async () => {
    if (!status) {
      return;
    }
    try {
      if (searchType === "Email" && prospectUiid) {
      const prospect = currentCompany?.jobIds
        ?.flatMap(job => job.prospectIds)
        ?.find(p => p.uiid === prospectUiid);

      if (prospect && prospect.inpersonResponseStatus === status) {
        showToast("Status is already updated", "info");
        setEditStatus(false);
        return;
      }
    } else {
      if (currentCompany?.status === status) {
        showToast("Status is already updated", "info");
        setEditStatus(false);
        return;
      }
    }
      if (searchType === "Email" && prospectUiid) {
        const payload = {
          payload: [
            {
              type: "SET",
              value: {
                inpersonResponseStatus: status,
                modifiedBy: user?.data?.uiid,
              },
            },
          ],
        };

        const res = await updateEmailstatusApi({
          uiid: prospectUiid,
          payload,
        });

        if (res?.data) {
          const updatedProspect = res.data.data.doc;
          setCurrentCompany(prev => {
            const updatedJobs = prev.jobIds?.map(job => {
              return {
                ...job,
                prospectIds: job.prospectIds?.map(p =>
                  p.uiid === updatedProspect.uiid ? updatedProspect : p
                )
              };
            });

            return {
              ...prev,
              jobIds: updatedJobs
            };
          });

          showToast("Prospect status updated", "success");
          setEditStatus(false);
        } else {
          showToast("Failed to update status of email", "error");
        }
        return;
      }
      else {
        const payload = {
          payload: [
            {
              type: "SET",
              value: { 
                status,
                modified: {             
                  by: user?.data?.uiid,
                  on: new Date()
                }
              },
            },
          ],
        };

        const response = await updateCompanystatusApi({
          uiid: currentCompany?.uiid,
          payload,
        });

        if (response?.success || response?.data) {
          showToast("Company status updated", "success");
          setEditStatus(false);
          setCurrentCompany(prev => ({  
            ...prev,
            ...response?.data?.data?.doc,
            jobIds: prev.jobIds,
          }));
        }
      }
    } catch (err) {
      showToast("Something went wrong", "error");
    }
  };
  return (
    <div className="w-full rounded overflow-hidden shadow">
      <div className="bg-info-50 px-4 py-3 flex items-start justify-between">
        <div>
          <InfoTextAdv
            title={"Account Name"}
            size="sm"
            titleProps={{ className: "!text-black" }}
            value={
              <div className="flex gap-1 items-center">
                <div className="text-primary-500 flex">
                  <span className="material-symbols-outlined leading-0">
                    domain
                  </span>
                </div>
                <div className="text-black text-base font-medium">
                  {/* {accountName} */}
                  {formatWords2(accountName)}
                </div>

                <div className="rounded bg-primary-300/0 p-1 relative ml-2">
                  <div className="bg-white/0 w-40">
                    {/* <FormFieldSet
                      type="citiesState"
                      title={"City/State"}
                      placeholder="Select City/State"
                      noTitle
                      size="sm"
                      value={location}
                      onChange={(value) => {
                        setLocation(value);
                        if (onLocationChange) onLocationChange(value.value);
                      }}
                      showSearch
                      parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                    /> */}
                    {/* change2  */}
                    {raSetting?.addCompanyWithLoc && (
                      <FormFieldSet
                        // type="citiesState"
                        type="atscitiesState"
                        title={"City/State"}
                        placeholder="Select City/State"
                        noTitle
                        size="sm"
                        value={location}
                        onChange={(value) => {
                          setLocation(value);
                          if (onLocationChange) onLocationChange(value.value);
                        }}
                        showSearch
                        parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                      />
                    )}
                  </div>
                  {/* {raSetting?.waitingPeriod != null && (
                    <div className="mt-1 text-sm text-gray-600">
                      Waiting Period: {raSetting.waitingPeriod} days
                    </div>
                  )} */}
                </div>
              </div>
            }
          />
        </div>
        <div>
          {/* <InfoTextAdv
            title={"Account Status"}
            size="sm"
            titleProps={{ className: "!text-black text-right" }}
            value={
              <div className="flex gap-0.5 items-center">
                {editStatus ? (
                  <>
                    <div className="w-30">
                      <FormFieldSet
                        type="select"
                        noTitle
                        placeholder="select"
                        size="xs-sm"
                        options={[
                          { label: "Active", value: 1 },
                          { label: "Blocked", value: 2 },
                        ]}
                        value={status}
                        onChange={(data) => {
                          setStatus(data);
                        }}
                      />
                    </div>
                    <Button
                      color="dark"
                      type="icon"
                      size="sm"
                      variant={"text"}
                      icon={"save"}
                      onClick={() => {
                        handleChangeStatus();
                      }}
                    />
                  </>
                ) : (
                  <>
                    <StatusTags tag={accountStatus} />

                    <Button
                      color="black"
                      type="icon"
                      size="sm"
                      variant={"text"}
                      icon={"edit_square"}
                      onClick={() => setEditStatus(true)}
                    />
                  </>
                )}
              </div>
            }
          /> */}
          <InfoTextAdv
            title={"Account Status"}
            size="sm"
            titleProps={{ className: "!text-black text-right" }}
            value={
              <div className="flex gap-0.5 items-center">
                {editStatus ? (
                  canEditStatus ? (
                    <>
                      <div className="w-30">
                        <FormFieldSet
                          type="select"
                          noTitle
                          placeholder="select"
                          size="xs-sm"
                          // options={[
                          //   { label: "Active", value: 1 },
                          //   { label: "Blocked", value: 2 },
                          // ]}
                          options={
                            searchType === "Email"
                              ? [
                                { label: "Active", value: 1 },
                                { label: "DNC", value: 3 },
                              ]
                              : [
                                { label: "Active", value: 1 },
                                { label: "Blocked", value: 2 },
                              ]
                          }
                          value={status}
                          onChange={(data) => setStatus(data)}
                        />
                      </div>
                      <Button
                        color="dark"
                        type="icon"
                        size="sm"
                        variant={"text"}
                        icon={"save"}
                        onClick={handleChangeStatus}
                      />
                    </>
                  ) : (
                    <StatusTags tag={displayedStatus} />
                  )
                ) : (
                  <>
                    <StatusTags tag={displayedStatus} />
                    {canEditStatus && (
                      <Button
                        color="black"
                        type="icon"
                        size="sm"
                        variant={"text"}
                        icon={"edit_square"}
                        onClick={() => setEditStatus(true)}
                      />
                    )}
                  </>
                )}
              </div>
            }
          />
        </div>
      </div>

      <div className="px-10 py-5 flex ">
        <div className="flex flex-1 w-full">
          <AdvSeparator gap="gap-6" center className="gap-y-6">
            {Object.keys(dataOther).map((key, index) => {
              if (key === "lockInPeriod" && currentCompany?.approval?.status === 3) {
                return null;
              }
              const value = key === "lastJobStatus" ? jobStatuses.find((data) => data.value === dataOther[key])?.label || ""
                : key === "accountApproval"
                  ? accountApprovalMap[dataOther[key]]
                  : dataOther[key];
              const isDate =
                value &&
                typeof value === "string" &&
                !isNaN(Date.parse(value)) &&
                new Date(value).getFullYear() > 1900 &&
                new Date(value).getFullYear() < 2100;

              const isUrl =
                value &&
                typeof value === "string" &&
                (value.startsWith("http://") ||
                  value.startsWith("https://") ||
                  value.startsWith("www.") ||
                  /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}/.test(
                    value
                  ));
                
              return (
                <InfoTextAdv
                  key={index}
                  title={keyToTitle(key)}
                  titleProps={{ className: "!text-black" }}
                  value={
                    <div>
                      {isDate ? (
                        <div className="text-sm text-dark font-medium text-nowrap ">
                          {/* {dateFormator(value, "short")} */}
                          {dateFormator(convertFromUTC(value), "short")}
                        </div>
                      ) : isUrl ? (
                        <SmartTooltip description={value} noicon>
                          <div className="text-sm text-info font-medium line-clamp-1 break-all">
                            <a
                              href={
                                value.startsWith("http")
                                  ? value
                                  : `https://${value}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="hover:underline"
                            >
                              {key === "website" ? value : "Link"}
                            </a>
                          </div>
                        </SmartTooltip>
                      ) : (
                        // <div className="text-sm text-black font-medium text-nowrap">
                        //   {value}
                        // </div>
                            key === "accountApproval" ? (
                              <StatusTags tag={value} icon={true}/>
                            ) : (
                              <div className="text-sm text-black font-medium whitespace-nowrap">
                                {typeof value === "string" ? formatWords2(value) : value}
                              </div>
                            )
                      )}
                    </div>
                  }
                />
              );
            })}
             {currentCompany?.status === 1 && !isBdm && currentCompany?.approval?.status !== 3 && [1, 11, 13].includes(dataOther?.lastJobStatus) &&
              lockInPeriodTime && ( // show only if Active AND unlocked and if company is not rejected
                <Button
                  title="Add Account"
                  icon="add"
                  onClick={() =>
                    handleAddNewLoc({
                      show: true,
                      website: currentCompany?.domain || "",
                      location,
                    })
                  }
                />
              )}
          </AdvSeparator>
        </div>
      </div>
    </div>
  );
};

export default AccountCard;
